// About.js
import React from 'react';
import '../css/About.css'; // Import your CSS file

function About() {
  return (
    <div className="about-container">
      <h2>About Us</h2>
      <p>Welcome to THE BOOK HAVEN, where passion meets pages. We are dedicated to bringing you a curated collection of literature that inspires, educates, and entertains. Whether you're an avid reader, a curious learner, or a literary enthusiast, our bookstore is your gateway to a world of stories.</p>

      <h3>Our Mission</h3>
      <p>At THE BOOK HAVEN, our mission is to foster a love for reading and learning within our community. We aim to provide:</p>
      <ul>
        <li><strong>Quality Selection:</strong> Handpicked books across genres, ensuring every reader finds their next favorite read.</li>
        <li><strong>Community Engagement:</strong> Events, book clubs, and author meet-ups that bring readers and writers together.</li>
        <li><strong>Exceptional Service:</strong> A personalized shopping experience with knowledgeable staff who are passionate about books.</li>
      </ul>

      <h3>Our Story</h3>
      <p>Founded by book lovers, THE BOOK HAVEN began with a simple idea: to create a haven where literature thrives. From humble beginnings, we've grown into a cherished part of our community, nurturing a love for books and storytelling.</p>

      <h3>Why Choose Us?</h3>
      <ul>
        <li><strong>Diverse Collection:</strong> From timeless classics to contemporary bestsellers, our shelves are stocked with a wide range of books to cater to every taste and interest.</li>
        <li><strong>Local Support:</strong> By shopping with us, you support local authors, publishers, and the literary community.</li>
        <li><strong>Passionate Team:</strong> Our team is driven by a shared passion for books. We're here to recommend your next great read and share our love for literature.</li>
      </ul>

      <h3>Visit Us</h3>
      <p>Explore our bookstore today and discover the magic of reading. Whether you're seeking inspiration, knowledge, or pure entertainment, THE BOOK HAVEN is your destination for all things literary.</p>

      <h3>Contact Us</h3>
      <p>Have questions or suggestions? We'd love to hear from you. Reach out to us at [deepanshutaneja762@gmail.com/9643345047].</p>
    </div>
  );
}

export default About;
